const { createSelector } = require('reselect')

const selectGetCertificateInfo = state => state.trustgateDomain.getCertificateInfo

const getCertificateInfo = () => createSelector(
  [selectGetCertificateInfo],
  cse => cse.data,
)

const getCertificateInfoError = () => createSelector(
  [selectGetCertificateInfo],
  cse => cse.error,
)

const getCertificateInfoLoading = () => createSelector(
  [selectGetCertificateInfo],
  cse => cse.loading,
)

module.exports = {
  getCertificateInfo,
  getCertificateInfoError,
  getCertificateInfoLoading,
}
